module.exports = __webpack_public_path__ + "img/publish-mail.1ef3e542.svg";